import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { getProposalDownloadURL } from 'api/operations/proposalServiceV3';
import { ProposalFileType } from 'types/proposalService';

interface DomainParams {
  cartId: string;
}

export default class PostSubmitDownloadProposalPageStore {
  private _domainParams: DomainParams;
  private _isLoading = false;
  private _pdfFilePath: string | null = null;
  private _xlsxFilePath: string | null = null;

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get pdfFilePath(): string | null {
    return this._pdfFilePath;
  }

  public get xlsxFilePath(): string | null {
    return this._xlsxFilePath;
  }

  public async getInitialData(): Promise<void> {
    this.setIsLoading(true);

    const [pdf, xlsx] = await Promise.all([
      getProposalDownloadURL(this._domainParams.cartId, ProposalFileType.PDF),
      getProposalDownloadURL(this._domainParams.cartId, ProposalFileType.SHEET),
    ]);

    runInAction(() => {
      this._pdfFilePath = pdf;
      this._xlsxFilePath = xlsx;
      this.setIsLoading(false);
    });
  }

  public setIsLoading(status: boolean): void {
    this._isLoading = status;
  }

  constructor(domainParams: DomainParams) {
    this._domainParams = domainParams;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const PostSubmitDownloadProposalPageStoreContext = createContext(
  new PostSubmitDownloadProposalPageStore({ cartId: 'stub-cart-id' } as DomainParams),
);

export const usePostSubmitDownloadProposalPageStore = (): PostSubmitDownloadProposalPageStore => {
  return useContext(PostSubmitDownloadProposalPageStoreContext);
};

export { PostSubmitDownloadProposalPageStoreContext };
